import { z } from 'zod';

export type ProcessingArgs = z.infer<typeof processingArgsSchema>;

/**
 * Arguments passed to a processing.
 *
 * Each argument is identified by its name and contains either a single value, an array of values,
 * or a key-value mapping (e.g. the `environment` argument).
 */
export const processingArgsSchema = z.record(
  z.string(),
  z.union([z.string(), z.array(z.string()), z.record(z.string(), z.string())]),
);
